/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useEffect, useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import * as S from '../../styles';

export interface ILandlineInputProps {
    id: string;
    fontScale?: number;
    label?: string;
    value?: string;
    required?: boolean;
    placeholder?: string;
    labelColor?: string;
    errorText?: string;
    groupText?: string;
    disabled?: boolean;
    hasError?: boolean;
    onCompChange?: (id: string, payload: string) => void;
}

export const Landline = ({
    id,
    fontScale,
    label,
    value = '',
    errorText,
    required,
    disabled,
    placeholder,
    groupText,
    onCompChange,
    labelColor,
    hasError,
}: ILandlineInputProps) => {
    const [textValue, setTextValue] = useState(value ?? '');
    const [isInvalid, setInvalid] = useState(false);

    useEffect(() => {
        setTextValue(value ?? '');
    }, [value]);

    useEffect(() => {
        if (hasError) {
            setInvalid(true);
        }
        if (!hasError) {
            if (isInvalid) {
                setInvalid(false);
            }
        }
    }, [hasError]);

    const formatPhoneNumber = (input: string) => {
        let digits = input.replace(/\D/g, '');
        if (digits.length <= 3) return digits;
        if (digits.length <= 6)
            return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
        return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(
            6,
            10
        )}`;
    };

    const handleChange = (id: string, e: any) => {
        const formattedValue = formatPhoneNumber(e?.target?.value);
        setTextValue(formattedValue.trim());
        console.log('Asir formattedvalue', formattedValue);
        if (onCompChange) onCompChange(id, formattedValue);
    };

    document.getElementById(`input-${id}`)?.addEventListener('focusin', (e) => {
        console.log(e, 'moi->');
        document
            .getElementById(`input-group-${id}`)
            ?.classList.add('input-group-ch');
    });
    document
        .getElementById(`input-${id}`)
        ?.addEventListener('focusout', (e) => {
            console.log(e, 'moi->');
            document
                .getElementById(`input-group-${id}`)
                ?.classList.remove('input-group-ch');
        });

    return (
        <Form.Group
            id={id}
            className="formgroup"
            style={{ backgroundColor: disabled ? '#F5F5F5' : '#fff' }}
        >
            {label && (
                <S.FormLabel fontScale={fontScale} color={labelColor}>
                    {label}
                    {required && <sup style={{ color: 'red' }}>*</sup>}
                </S.FormLabel>
            )}
            <InputGroup id={`input-group-${id}`} className="input-group-bt">
                {groupText && (
                    <InputGroup.Text id="basic-addon1">
                        {groupText}
                    </InputGroup.Text>
                )}
                <S.FormControl
                    fontScale={fontScale}
                    className="formcontrol input shadow-none"
                    id={`input-${id}`}
                    value={textValue}
                    onChange={handleChange.bind(null, id)}
                    required={required}
                    disabled={disabled}
                    type="text"
                    placeholder={placeholder}
                    isInvalid={isInvalid}
                    style={{ backgroundColor: disabled ? '#F5F5F5' : '#fff' }}
                />
            </InputGroup>
            {hasError && errorText && (
                <InputGroup>
                    <S.FeedbackOtherLabel type="tooltip" fontScale={fontScale}>
                        {errorText}
                    </S.FeedbackOtherLabel>
                </InputGroup>
            )}
        </Form.Group>
    );
};

Landline.defaultProps = {
    required: false,
    disabled: false,
    hasError: false,
};
